import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {Badge} from "primereact/badge";

const PurhcaseorderListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [purchaseorders, setPurchaseorders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [statusDictionary, setStatusDictionary] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const labelForStatus = (key) => {
    if (!key) return '';
    const hit = statusDictionary.find(s => String(s.key).toUpperCase() === String(key).toUpperCase());
    return hit?.value || key;
  };

  const severityForStatus = (status) => {
    switch (String(status || '').toUpperCase()) {
      case 'NEW':
      case 'IN_PROGRESS':
        return 'warning';

      case 'COMPOSED':
      case 'ORDERED':
      case 'RECEIVING':
        return 'orange';

      case 'CLOSED':
        return 'success';

      case 'DELETED':
        return 'danger';

      default:
        return 'info';
    }
  };

  const statusBodyTemplate = (rowData) => {
    const status = rowData?.status;
    const severity = severityForStatus(status);
    return (
      <Badge
        value={labelForStatus(status)}
        severity={severity === 'orange' ? null : severity}
        style={severity === 'orange' ? {
          backgroundColor: '#f97316',
          color: '#ffffff'
        } : {}}
      />
    );
  };

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/purchase-order' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setPurchaseorders(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_purchase_order_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'purchase-order') {
                      history.push('/procurement/purchase-order/update/' + rowData.id + '&return=/procurement/purchase-order')
                    }
                  }}/>
        }
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                tooltip={t('view')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  history.push('/procurement/purchase-order/read/' + rowData.id)
                }}/>
        {localStorage.getItem('roles').toString().includes('role_purchase_order_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/purchase-order/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderPurchaseorderList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderPurchaseorderList])

  useEffect(() => {
    apiCall('GET', '/api/v2/dictionary/purchase-order-status')
      .then(res => setStatusDictionary(res.data?.data || []))
      .catch(err => window.App.toastShow('error', t('error'), err.toString(), '', err.response));
  }, []);

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={purchaseorders} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="purchase_order_number" header={t('columnPurchaseOrderNumber')} bodyClassName="col-body-font-bold" sortable filter></Column>
        {/*<Column field="expected_delivery_date" header={t('columnDeadline')} sortable filter body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.expected_delivery_date)}</>
          )
        }}></Column>*/}
        <Column field="status" header={t('columnStatus2')} sortable filter body={statusBodyTemplate}></Column>

{/* 
        //   return(
        //     <>
        //       {rowData?.status === 'NEW' &&
        //         <>Új</>
        //       }
        //       {rowData?.status === 'IN_PROGRESS' &&
        //         <>Folyamatban</>
        //       }
        //       {rowData?.status === 'DONE' &&
        //         <>Kész</>
        //       }
        //       {rowData?.status === 'DELETED' &&
        //         <>Törölt</>
        //       }
        //       {rowData?.status === 'COMPOSED' &&
        //         <>Szerkesztett</>
        //       }
        //       {rowData?.status === 'ORDERED' &&
        //         <>Megrendelve</>
        //       }
        //     </>
        //   )
        // }}></Column> */}
        
        {/* <Column field="location.name" header={t('columnLocation')} sortable filter></Column> */}
        <Column field="project.name" header={t('columnProject')} sortable filter></Column>
        <Column field="warehouse.name" header={t('columnWarehouse')} sortable filter></Column>
        <Column field="contact.name" header={t('columnRequester')} sortable filter></Column>
        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(PurhcaseorderListComponent);
